import {
  DashboardOutlined,
  InfoCircleOutlined,
  LogoutOutlined,
  MenuFoldOutlined,
  MenuUnfoldOutlined,
  MoneyCollectOutlined,
  RocketOutlined,
  ShopOutlined,
} from "@ant-design/icons";
import { Avatar, Button, Divider, Flex, Layout, Menu, Select, Space, theme, Typography } from "antd";
import { useContext, useEffect, useState } from "react";
import { Link, Outlet, useNavigate } from "react-router-dom";
import AppContext from "./AppContext";
import { useQuery } from "react-query";
import { Curl } from "components/Jarvis";

const { Title, Text } = Typography;
export default function RestrictedLayout() {
  const [firstRender, setFirstRender] = useState(true);
  const navigate = useNavigate();
  const { signOut, user } = useContext(AppContext);

  const { data, isFetching } = useQuery(["currentMerchant"], () => {
    return Curl.get(`/payplus/resources/current_merchant`).then((res) => {
      const newOptions = res.payload.map((element) => ({
        value: element.id,
        label: element.display_name,
      }));

      return newOptions;
    });
  });

  useEffect(() => {
    sessionStorage.setItem("isReloaded", false);
  }, []);

  useEffect(() => {
    if (sessionStorage.getItem("isReloaded") == "false" && data !== undefined) {
      sessionStorage.setItem("isReloaded", "true");
      localStorage.setItem("XMerchant", data[0].value);
      localStorage.setItem("Merchant_name", data[0].label);
    }
  }, [data]);

  const filterOption = (input, option) => (option?.label ?? "").toLowerCase().includes(input.toLowerCase());

  const onChange = (value, option) => {
    localStorage.setItem("XMerchant", value);
    localStorage.setItem("Merchant_name", option.label);
    window.location.reload();
  };
  const {
    token: { colorBgContainer, borderRadiusLG },
  } = theme.useToken();

  const [collapsed, setCollapsed] = useState(false);

  return (
    <Layout>
      <Layout.Sider
        width={230}
        style={{
          overflow: "auto",
          height: "100vh",
          position: "fixed",
          left: 0,
          top: 0,
          bottom: 0,
        }}
        // style={{
        //   overflow: "auto",
        //   height: "100svh",
        //   position: "fixed",
        //   left: 0,
        //   top: 0,
        //   bottom: 0,
        // }}
        breakpoint="lg"
        collapsedWidth="0"
        trigger={null}
        collapsible
        collapsed={collapsed}
        onBreakpoint={(broken) => {}}
        onCollapse={(collapsed) => setCollapsed(collapsed)}
      >
        <div className="demo-logo-vertical" />
        <a href="/">
          <img
            src="https://d3llrj9jceo0wb.cloudfront.net/img/cropped-payplus-logo-2019-white-300x96.png"
            width="150"
            align="center"
            alt="PAYPLUS"
            style={{
              margin: 15,
            }}
          />
        </a>

        <Menu
          inlineIndent={10}
          theme="dark"
          mode="inline"
          items={[
            ...(data && data.length > 0
              ? [
                  {
                    key: "test",
                    icon: <ShopOutlined />,
                    label: (
                      <Flex align="center" justify="space-between">
                        {data.length > 1 ? (
                          <Select
                            onChange={onChange}
                            filterOption={filterOption}
                            value={localStorage.getItem("Merchant_name") !== "" ? localStorage.getItem("Merchant_name") : data[0]}
                            showSearch
                            options={data.map((item) => ({ value: item }))}
                            style={{ width: "100%" }}
                          />
                        ) : (
                          localStorage.getItem("Merchant_name")
                        )}
                      </Flex>
                    ),
                  },
                ]
              : []),
            // {
            //   key: "/dashboard",
            //   icon: <DashboardOutlined />,
            //   label: <Link to={"/"}>Dashboard</Link>,
            // },
            // {
            //   key: "/information",
            //   icon: <InfoCircleOutlined />,
            //   label: <Link to={"/information"}>Information</Link>,
            // },
            {
              key: "/information",
              icon: <InfoCircleOutlined />,
              label: <Link to={"/"}>Information</Link>,
            },
            // {
            //   key: "/settlement-dashboard",
            //   icon: <MoneyCollectOutlined />,
            //   label: (
            //     <Link to={"/settlement-dashboard"}>Settlements Dashboard</Link>
            //   ),
            // },
            {
              key: "/terminal",
              icon: <RocketOutlined />,
              label: <Link to={"/terminal"}>Terminal</Link>,
            },
            {
              key: "/payments",
              icon: <MoneyCollectOutlined />,
              label: <Link to={"/payments"}>Payments</Link>,
            },
            {
              key: "/settlements",
              icon: <MoneyCollectOutlined />,
              label: <Link to={"/settlements"}>Settlements</Link>,
            },
            // {
            //   key: "/users",
            //   icon: <UserOutlined />,
            //   label: <Link to={"/users"}>Users</Link>,
            // },
          ]}
        />

        <div
          style={{
            position: "absolute",
            bottom: 0,
            width: "100%",
            textAlign: "center",
          }}
        >
          <Space direction="vertical" style={{ display: "flex", padding: 16 }}>
            <Button
              onClick={() => {
                localStorage.clear();
                sessionStorage.removeItem("isReloaded");
                navigate(0);
              }}
              icon={<LogoutOutlined />}
              block
            >
              Logout
            </Button>
            <div className="light-text">Last Login Time</div>
            <div className="light-text">2023 May 11 23:20</div>
          </Space>
        </div>
      </Layout.Sider>

      <Layout
        style={{
          marginLeft: collapsed ? 0 : 230,
          transition: "margin-left 0.3s",
        }}
      >
        <Layout.Header
          style={{
            // position: "sticky",
            // top: 0,
            // zIndex: 1000,
            // backgroundColor: "transparent",
            paddingBottom: 0,
            height: "inherit",
            lineHeight: "inherit",
            padding: 16,
            backgroundColor: "#f5f5f5",
            borderBottom: "#dddddd solid 1px",
            verticalAlign: "middle",
          }}
        >
          <Button
            type="text"
            icon={collapsed ? <MenuUnfoldOutlined /> : <MenuFoldOutlined />}
            onClick={() => setCollapsed(!collapsed)}
            style={{ fontSize: "16px", width: 32, height: 32 }}
          />
          {/* <div style={{ display: "inline-block" }}>
            <Breadcrumb
              items={[{ title: "Home", href: "/merchant/" }]}
              separator=">"
            />
          </div> */}
          <div style={{ float: "right" }}>
            <Flex
              align="center"
              style={{
                cursor: "pointer",
                marginTop: "3px",
                // fontSize: "16px",
                height: "32px",
              }}
            >
              <Avatar size="small">M</Avatar>
              <span style={{ margin: "0 3px" }}></span>

              <div className="user-infos">
                <div className="user-display-name">Merchant</div>
              </div>
            </Flex>
          </div>
        </Layout.Header>
        <Layout.Content style={{ padding: 16 }}>
          {/* <Suspense fallback={<Skeleton />}> */}
          <Outlet />
          {/* </Suspense> */}
        </Layout.Content>
        <Layout.Footer style={{ padding: 16 }}>
          <Divider orientation="left" orientationMargin={0} style={{ fontSize: 13, marginBottom: 8, marginTop: 0 }}>
            Powered by
          </Divider>
          PAYPLUS LIMITED
        </Layout.Footer>
      </Layout>
    </Layout>
  );
}
